import DisplayCategories from './DisplayCategories';
import './styles.scss';

const exports = { DisplayCategories };
export default exports;
